import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class PriAttribute extends Sensor {
  public priChart: any;
  private priSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.priChart = null;
    this.priSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.priSensor, position);
      this.priSensor[position].push([timestamp, element.pri]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredPri = this.priSensor.filter(series => series.length > 0);

    const positionNodePri = this.priSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.priChart = this.getConfigChar(
      'pri',
      this.getChartSeriesNewNode('Índice PRI', filteredPri, positionNodePri),
      this.getRanges('pri'),
      this.getLimits('pri')
    );
  }

  public hasPriSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.priSensor.length &&
      this.priSensor[index].length > 0
    );
  }

  public getPriSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.priSensor.length) {
      const sensorData = this.priSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Índice PRI', value: 'pri' }
    ];
  }
}
